import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "company-information-form-locked" }
const _hoisted_2 = { class: "typographies-paragraph-medium-regular" }
const _hoisted_3 = { class: "typographies-paragraph-medium-regular" }
const _hoisted_4 = { class: "typographies-paragraph-medium-regular" }
const _hoisted_5 = { class: "typographies-paragraph-medium-regular" }
const _hoisted_6 = { class: "typographies-paragraph-medium-regular" }

import { ref, computed, watch, inject } from 'vue';
import { Translator, PushToast } from 'js/shims-vue';
import { updateAccountInformation } from 'api/account/account';
import CompanyInformationFormAdvice from 'vcomponents/preferences/CompanyInformation/CompanyInformationFormAdvice.vue';
import type {
    CompanyData,
    Country,
} from 'vcomponents/preferences/CompanyInformation/CompanyInformation.vue';
import { useStore } from 'vuex';

interface Props {
    data: CompanyData;
    countries: Country[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyInformationFormLocked',
  props: {
    data: {},
    countries: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

// Store
const store = useStore();

const legalStatus = ref<string>(props.data.legal_france.company_type || '');
const shareCapital = ref<string>(props.data.capital || '');
const naf = ref<string>(props.data.legal_france.ape_naf_code || '');
const rcs = ref<string>(props.data.legal_france.rcs_immatriculation || '');
const isLoading = ref<boolean>(false);

const tooltipText = computed(() => $t.__('CompanyInformation.lock.tooltip'));
const numformat = computed(() => store.state.corp.numformat);
const showCurrencyLeft = computed((): boolean => {
    return numformat.value.currencypos === 'left' || numformat.value.currencypos === 'both';
});
const showCurrencyRight = computed((): boolean => {
    return numformat.value.currencypos === 'right' || numformat.value.currencypos === 'both';
});

watch(
    () => props.data,
    (newData): void => {
        legalStatus.value = newData.legal_france.company_type || '';
        shareCapital.value = newData.capital || '';
        naf.value = newData.legal_france.ape_naf_code || '';
        rcs.value = newData.legal_france.rcs_immatriculation || '';
    },
    { deep: true },
);
const errors = ref({
    legalStatus: '',
    shareCapital: '',
    naf: '',
    rcs: '',
});

const countryName = computed((): string => {
    if (!props.data.country_code || props.countries.length === 0) {
        return '';
    }
    const country = props.countries.find(
        (country) => country.code.toLowerCase() === props.data.country_code.toLowerCase(),
    );
    return country?.name || '';
});

const handleSubmit = async (): Promise<void> => {
    isLoading.value = true;
    try {
        const payload: Record<string, unknown> = {
            legal_france: {
                company_type: legalStatus.value || null,
                ape_naf_code: naf.value || null,
                rcs_immatriculation: rcs.value || null,
            },
            capital: shareCapital.value || null,
        };

        const fieldsToValidate = [
            'legal_france.company_type',
            'legal_france.ape_naf_code',
            'legal_france.rcs_immatriculation',
            'capital',
        ];

        const response = await updateAccountInformation(payload, fieldsToValidate);
        emit('update', response.data);
        $pushToast({
            type: 'success',
            text: $t.__('CompanyInformation.legal_information.save.success'),
        });
    } catch (error: unknown) {
        const apiError = (
            error as { response?: { data?: { error?: { details?: Record<string, string> } } } }
        )?.response?.data?.error?.details;
        const fieldMap: Record<string, keyof typeof errors.value> = {
            company_type: 'legalStatus',
            capital: 'shareCapital',
            ape_naf_code: 'naf',
            rcs_immatriculation: 'rcs',
        };
        if (apiError) {
            for (const key of Object.keys(apiError)) {
                const shortenedKey = key.split('.').pop() as string;
                if (fieldMap[shortenedKey]) {
                    errors.value[fieldMap[shortenedKey]] = apiError[key];
                }
            }
        }
        $pushToast({
            type: 'error',
            text: $t.__('CompanyInformation.legal_information.save.error'),
        });
    } finally {
        isLoading.value = false;
    }
};

return (_ctx: any,_cache: any) => {
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!
  const _component_CompassFormItem = _resolveComponent("CompassFormItem")!
  const _component_CompassInput = _resolveComponent("CompassInput")!
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.country_label'),
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTooltip, {
          content: tooltipText.value,
          arrow: false,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(countryName.value), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.siren_label'),
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTooltip, {
          content: tooltipText.value,
          arrow: false,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.data.legal_france.siren), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.siret_label'),
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTooltip, {
          content: tooltipText.value,
          arrow: false,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.data.legal_france.siret), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.company_name_label'),
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTooltip, {
          content: tooltipText.value,
          arrow: false,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(__props.data.legal_name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.vat_number_label'),
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTooltip, {
          content: tooltipText.value,
          arrow: false,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.data.legal_france.vat), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.legal_status_label'),
      error: errors.value.legalStatus,
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassInput, {
          modelValue: legalStatus.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((legalStatus).value = $event)),
          error: !!errors.value.legalStatus,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (errors.value.legalStatus = ''))
        }, null, 8 /* PROPS */, ["modelValue", "error"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "error"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.share_capital_label'),
      error: errors.value.shareCapital,
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassInput, {
          modelValue: shareCapital.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shareCapital).value = $event)),
          error: !!errors.value.shareCapital,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (errors.value.shareCapital = ''))
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          (showCurrencyLeft.value)
            ? {
                name: "prefix",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(numformat.value.currencysymbol), 1 /* TEXT */)
                ]),
                key: "0"
              }
            : undefined,
          (showCurrencyRight.value)
            ? {
                name: "suffix",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(numformat.value.currencysymbol), 1 /* TEXT */)
                ]),
                key: "1"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "error"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "error"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.naf_code_label'),
      error: errors.value.naf,
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassInput, {
          modelValue: naf.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((naf).value = $event)),
          error: !!errors.value.naf,
          onInput: _cache[5] || (_cache[5] = ($event: any) => (errors.value.naf = ''))
        }, null, 8 /* PROPS */, ["modelValue", "error"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "error"]),
    _createVNode(_component_CompassFormItem, {
      label: _unref($t).__('CompanyInformation.legal_information.rcs_label'),
      error: errors.value.rcs,
      orientation: "horizontal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassInput, {
          modelValue: rcs.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((rcs).value = $event)),
          error: !!errors.value.rcs,
          onInput: _cache[7] || (_cache[7] = ($event: any) => (errors.value.rcs = ''))
        }, null, 8 /* PROPS */, ["modelValue", "error"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "error"]),
    _createVNode(CompanyInformationFormAdvice),
    _createVNode(_component_CompassButton, {
      class: "company-information-form-locked__update-button",
      label: _unref($t).__('common.actions.update'),
      loading: isLoading.value,
      type: _ctx.CompassEnums.ButtonType.TERTIARY,
      onClick: handleSubmit
    }, null, 8 /* PROPS */, ["label", "loading", "type"])
  ]))
}
}

})